import { render, staticRenderFns } from "./OrderSubmission.vue?vue&type=template&id=0058fb74&scoped=true"
import script from "./OrderSubmission.vue?vue&type=script&lang=js"
export * from "./OrderSubmission.vue?vue&type=script&lang=js"
import style0 from "./OrderSubmission.vue?vue&type=style&index=0&id=0058fb74&prod&scoped=true&lang=scss"
import style1 from "./OrderSubmission.vue?vue&type=style&index=1&id=0058fb74&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0058fb74",
  null
  
)

export default component.exports